define.alias("shared/components/shared/card/header", "calendar/components/shared/card/header");